import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettingNotification: React.FC<IconProps> = ({ width = 20, height = 20, color }) => {
    const strokeColor = color || '#7F7F7F';

    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_83598)">
                <path
                    d="M7.5 17.5H12.5"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4.37124 8.125C4.37124 6.63316 4.96387 5.20242 6.01876 4.14752C7.07366 3.09263 8.5044 2.5 9.99624 2.5C11.4881 2.5 12.9188 3.09263 13.9737 4.14752C15.0286 5.20242 15.6212 6.63316 15.6212 8.125C15.6212 10.9234 16.2697 13.1719 16.7853 14.0625C16.8401 14.1574 16.8689 14.2649 16.869 14.3745C16.8691 14.484 16.8404 14.5916 16.7859 14.6865C16.7313 14.7815 16.6527 14.8604 16.558 14.9154C16.4633 14.9705 16.3558 14.9996 16.2462 15H3.74624C3.63685 14.9993 3.52955 14.97 3.43506 14.9149C3.34057 14.8597 3.2622 14.7808 3.20779 14.6859C3.15338 14.591 3.12483 14.4835 3.125 14.3741C3.12517 14.2647 3.15404 14.1572 3.20874 14.0625C3.72358 13.1719 4.37124 10.9227 4.37124 8.125Z"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_83598">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettingNotification;
